<script setup lang="ts">
// import * as locales from '@nuxt/ui/locale'
const currentUrl = useRequestURL()
const config = useRuntimeConfig()

if (config?.public?.landingSiteHosts && config?.public?.landingSiteHosts.includes(currentUrl.origin)) {
  setPageLayout('landing')
}
</script>

<template>
  <Html class="scroll-smooth bg-[#f2f2f2]">
    <!-- <VitePwaManifest /> -->

    <Body
      class="antialiased text-med-deep-navy max-w-[1920px] mx-auto card-shadow 180-body"
      style="margin-right:auto !important"
    >
      <NuxtLoadingIndicator
        :color="false"
        class="bg-gradient-to-r from-med-navy via-med-blue via-70% to-info shadow-sm shadow-[var(--color-med-aqua)]"
      />
      <UApp>
        <NuxtLayout>
          <slot />
        </NuxtLayout>
      </UApp>
      <UiSonner />
    </Body>
  </Html>
</template>
